import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-archive-list-item',
  templateUrl: './archive-list-item.component.html',
  styleUrls: ['./archive-list-item.component.scss']
})
export class ArchiveListItemComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
